<div class="contents-area">
  <wj-tab-panel id="tab_KYMW6901" #tab_KYMW6901 [(selectedIndex)]="model.selectedTabIndex" [tabindex]="-1"
    forcedEnabledMode="true">
    <wj-tab>
      <a>提案項目</a>
      <div>
        <app-kymw6901-proposal-tab [mode]="model.mode" [passedProposalId]="model.proposalId"
          [pCode]="model.pCode" [itemCode]="model.itemCode" [classCode]="model.classCode"
          [proposalId]="model.proposalId" [masterInputId]="model.masterInputId"
          [searchParams]="model.kymw6900SearchParams"></app-kymw6901-proposal-tab>
      </div>
    </wj-tab>
    <wj-tab>
      <a>マスタ入力表</a>
      <div>
        <app-kymw6901-master-input-tab [mode]="model.mode" [pCode]="model.pCode" [itemCode]="model.itemCode" [classCode]="model.classCode"
          [proposalId]="model.proposalId" [masterInputId]="model.masterInputId" [proposalStatus]="model.proposalStatus"
          [searchParams]="model.kymw6900SearchParams"></app-kymw6901-master-input-tab>
      </div>
    </wj-tab>
  </wj-tab-panel>
</div>

<footer class="footer-buttons">
  <button class="btn-tartiary" [tabindex]="0" (click)="eventBack_CLICKHandler()">商品提案検索画面に戻る</button>
</footer>